import Logger from '../fw/logger';


export default class AdScheduler {

  #rmp;
  #adSchedulerCheckerFn = null;
  #liveAdSchedulerInterval = null;
  #liveAdSchedulerIndex = 0;
  #adScheduleOnAdStartedFn = null;
  #adScheduleOnContentResumeRequestedFn = null;
  #adScheduleOnAdErrorFn = null;
  #adScheduleOnAdDestroyedFn = null;
  #playSchedulerFn = null;
  #adSchedulerEndedFn = null;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  static prepareMidRolls() {
    if (Array.isArray(this.adSchedule.midrollRepeat) &&
      typeof this.adSchedule.midrollRepeat[0] === 'number' &&
      typeof this.adSchedule.midrollRepeat[1] === 'string') {
      this.adSchedule.midroll = [];
      for (let i = 0, len = 100; i < len; i++) {
        this.adSchedule.midroll[i] = [
          this.adSchedule.midrollRepeat[0] * (i + 1),
          this.adSchedule.midrollRepeat[1]
        ];
      }
      delete this.adSchedule.midrollRepeat;
    }
    if (Array.isArray(this.adSchedule.midroll) &&
      Array.isArray(this.adSchedule.midroll[0]) &&
      this.adSchedule.midroll[0].length === 2) {
      this.scheduleHasMidRolls = true;
    }
  }

  #adScheduleOnAdStarted() {
    this.#rmp.off('adstarted', this.#adScheduleOnAdStartedFn);
    if (!this.#rmp.adLinear) {
      this.#rmp.on('timeupdate', this.#adSchedulerCheckerFn);
    }
  }

  #adScheduleResetEvents() {
    this.#rmp.off('adstarted', this.#adScheduleOnAdStartedFn);
    this.#rmp.off('aderror', this.#adScheduleOnAdErrorFn);
    this.#rmp.off('adcontentresumerequested', this.#adScheduleOnContentResumeRequestedFn);
  }

  #adScheduleOnContentResumeRequested() {
    this.#adScheduleResetEvents();
    this.#rmp.on('timeupdate', this.#adSchedulerCheckerFn);
  }

  #adScheduleOnAdError() {
    this.#adScheduleResetEvents();
    this.#rmp.on('timeupdate', this.#adSchedulerCheckerFn);
  }

  #adScheduleOnAdDestroyed() {
    this.#rmp.off('adstarted', this.#adScheduleOnAdStartedFn);
    this.#rmp.off('addestroyed', this.#adScheduleOnAdDestroyedFn);
    this.#rmp.on('timeupdate', this.#adSchedulerCheckerFn);
  }

  #adSchedulerChecker() {
    let time;
    if (this.#rmp.isVod) {
      const currentTime = this.#rmp.currentTime;
      if (currentTime > -1) {
        time = currentTime / 1000;
      }
    } else {
      time = this.#liveAdSchedulerIndex;
    }
    Logger.print('advertisement', 'adScheduler: actual currentTime  is ' + time + 's');
    let adTime;
    let adTagUrl;
    if (Array.isArray(this.#rmp.adSchedule.midroll) && Array.isArray(this.#rmp.adSchedule.midroll[0])) {
      adTime = this.#rmp.adSchedule.midroll[0][0];
      adTagUrl = this.#rmp.adSchedule.midroll[0][1];
      if (typeof adTime === 'number' && typeof time === 'number' && time > adTime && typeof adTagUrl === 'string' && adTagUrl !== '') {
        Logger.print('advertisement', 'adScheduler: parsed input time is ' + adTime + 's');
        // remove time checker before ad load
        if (this.#rmp.isVod) {
          this.#rmp.off('timeupdate', this.#adSchedulerCheckerFn);
          // on adstarted and if non-linear re-enabled time checker
          // both IMA + rmp-vast
          this.#adScheduleOnAdStartedFn = this.#adScheduleOnAdStarted.bind(this);
          this.#rmp.on('adstarted', this.#adScheduleOnAdStartedFn);
          if (this.#rmp.adParser === 'ima') {
            // for linear ads on adcontentresumerequested re-enabled time checker
            this.#adScheduleOnContentResumeRequestedFn = this.#adScheduleOnContentResumeRequested.bind(this);
            this.#rmp.on('adcontentresumerequested', this.#adScheduleOnContentResumeRequestedFn);
            // on aderror re-enabled time checker
            this.#adScheduleOnAdErrorFn = this.#adScheduleOnAdError.bind(this);
            this.#rmp.on('aderror', this.#adScheduleOnAdErrorFn);
          } else {
            // on addestroyed (which covers aderror and adcomplete) re-enabled time checker
            this.#adScheduleOnAdDestroyedFn = this.#adScheduleOnAdDestroyed.bind(this);
            this.#rmp.on('addestroyed', this.#adScheduleOnAdDestroyedFn);
          }
        }
        this.processAdScheduleCallback(adTagUrl, false);
        // removed already played ads but only is not in progress otherwise retry next tick
        this.#rmp.adSchedule.midroll.shift();
      }
    }
  }

  // postroll request 
  #adSchedulerEnded() {
    this.#rmp.off('ended', this.#adSchedulerEndedFn);
    if (this.#rmp.adSchedule.postroll) {
      this.processAdScheduleCallback(this.#rmp.adSchedule.postroll, false);
    }
  }

  #playScheduler() {
    this.#rmp.off('play', this.#playSchedulerFn);
    this.#liveAdSchedulerInterval = window.setInterval(() => {
      if (this.#rmp.paused) {
        return;
      }
      const adOnStage = this.#rmp.adOnStage;
      if (!adOnStage || (adOnStage && !this.#rmp.adLinear)) {
        this.#liveAdSchedulerIndex++;
        this.#adSchedulerChecker();
      }
    }, 1000);
  }

  #filterMidRolls(duration) {
    let indexToRemove = [];
    this.#rmp.adSchedule.midroll.forEach((midrollItem, index) => {
      if (typeof midrollItem[0] === 'string') {
        if (this.#rmp.isVod && duration > -1) {
          let percent = midrollItem[0].trim().split('%');
          percent = percent[0];
          midrollItem[0] = (duration * percent) / 100 / 1000;
        } else {
          indexToRemove.push(index);
        }
      }
    });
    if (indexToRemove.length > 0) {
      for (let i = indexToRemove.length - 1; i >= 0; i--) {
        this.#rmp.adSchedule.midroll.splice(indexToRemove[i], 1);
      }
    }
    this.#rmp.adSchedule.midroll.sort((a, b) => {
      return a[0] - b[0];
    });
    Logger.print('advertisement', 'adScheduler: filtered mid-roll items follow', this.#rmp.adSchedule.midroll);
  }

  #addTimelineAdMarkers(duration) {
    let arrayMarkers = [];
    if (this.#rmp.adSchedule.preroll) {
      arrayMarkers.push(0);
    }
    if (Array.isArray(this.#rmp.adSchedule.midroll)) {
      this.#rmp.adSchedule.midroll.forEach(midrollItem => {
        arrayMarkers.push(midrollItem[0] * 1000);
      });
    }
    if (this.#rmp.adSchedule.postroll) {
      arrayMarkers.push(Infinity);
    }
    Logger.print('advertisement', 'adScheduler: markers follow', arrayMarkers);
    this.#rmp.rmpAdsHelpers.createAdMarkers(arrayMarkers, duration);
  }

  prepareSchedule() {
    Logger.print('advertisement', 'adScheduler: prepareSchedule');
    this.#rmp.adTagReloadOnEnded = this.#rmp.adScheduleReloadOnEnded;
    this.#rmp.adTagUrl = '';
    // adScheduleWaterfall
    if (Array.isArray(this.#rmp.adScheduleWaterfall) && this.#rmp.adScheduleWaterfall.length > 0) {
      this.#rmp.adTagWaterfall = this.#rmp.adScheduleWaterfall;
    }
    // remove post roll if loop is enabled
    if (this.#rmp.adSchedule.postroll && this.#rmp.loopConfiguration) {
      delete this.#rmp.adSchedule.postroll;
    }
    if (!this.#rmp.adSchedule.preroll) {
      this.#rmp.emptyInitAdTagUrl = true;
      this.#rmp.adSchedule.preroll = '';
    }
    if (!this.#rmp.adSchedule.postroll) {
      this.#rmp.adSchedule.postroll = '';
    }
  }

  processAdScheduleCallback(adTagUrl, firstPlayAdRequest) {
    if (typeof this.#rmp.adScheduleCallback === 'function') {
      this.#rmp.adScheduleCallback().then(callbackAdTagUrl => {
        this.#rmp.loadAds(callbackAdTagUrl, ['internal'], firstPlayAdRequest).catch(error => {
          this.#rmp.rmpUtils.warning(1020, error);
          this.#rmp.rmpUtils.playPromise();
        });
      }).catch(warning => {
        console.warn(warning);
      });
    } else {
      this.#rmp.loadAds(adTagUrl, ['internal'], firstPlayAdRequest).catch(error => {
        this.#rmp.rmpUtils.warning(1020, error);
        this.#rmp.rmpUtils.playPromise();
      });
    }
  }

  destroy() {
    this.#adScheduleResetEvents();
    this.#rmp.off('addestroyed', this.#adScheduleOnAdDestroyedFn);
    this.#rmp.off('timeupdate', this.#adSchedulerCheckerFn);
    this.#rmp.off('ended', this.#adSchedulerEndedFn);
    this.#rmp.off('play', this.#playSchedulerFn);
    window.clearInterval(this.#liveAdSchedulerInterval);
  }

  wireSchedulerEndedEvents() {
    this.#adSchedulerEndedFn = this.#adSchedulerEnded.bind(this);
    this.#rmp.on('ended', this.#adSchedulerEndedFn);
  }

  update(newSchedule) {
    this.destroy();
    this.#rmp.rmpInitManagement.unwireInitAdEvents();
    this.#rmp.rmpAdsHelpers.clearAdMarkers();
    this.#rmp.adSchedule = newSchedule;
    this.#rmp.adTagReloadOnEnded = this.#rmp.adScheduleReloadOnEnded = false;
    AdScheduler.prepareMidRolls.call(this.#rmp);
    if (this.#rmp.adSchedule.preroll || this.#rmp.adSchedule.postroll || this.#rmp.scheduleHasMidRolls) {
      this.#rmp.rmpAdScheduler = new AdScheduler(this.#rmp);
      this.#rmp.rmpAdScheduler.prepareSchedule();
      const duration = this.#rmp.duration;
      this.#rmp.rmpAdScheduler.init(duration);
    }
  }

  init(duration) {
    Logger.print('advertisement', 'adScheduler: init');
    // filterMidRolls
    if (this.#rmp.scheduleHasMidRolls) {
      this.#filterMidRolls(duration);
    }
    this.#adSchedulerCheckerFn = this.#adSchedulerChecker.bind(this);
    if (this.#rmp.isVod) {
      this.#rmp.on('timeupdate', this.#adSchedulerCheckerFn);
      // postroll handling
      this.wireSchedulerEndedEvents();
      // adShowMarkers
      if (this.#rmp.adShowMarkers) {
        this.#addTimelineAdMarkers(duration);
      }
    } else {
      this.#playSchedulerFn = this.#playScheduler.bind(this);
      this.#rmp.on('play', this.#playSchedulerFn);
    }
  }

}
